import React, {Fragment, useContext, useState} from 'react';
import {
  Box,
  Typography,
  Button,
} from '@mui/material';
import { ConfirmationDialog } from '../../components/boilerplate/ConfirmationDialog';
import { openEvaluation } from '../../services';
import {DefinitionsContext} from "../../context/DefinitionsContext";

function OpenEvaluationDialog({isPermitted, onChange}) {
  const [confirmModal, setConfirmModal] = useState(false);
  const { translationList } = useContext(DefinitionsContext);

  return (
    <Box
      sx={{
        height: '240px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          paddingTop: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
        }}
      >
      <Typography>
          {translationList.evaluationNotOpenedYet}
      </Typography>
      { isPermitted &&
      <Typography>
          {translationList.openEvaluationForEvent}
      </Typography>
      }
      </Box>
      {isPermitted &&
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={() => onChange()}
        >{translationList.openEvaluation}</Button>
      </Box>
      }
    </Box>
  );
}

export { OpenEvaluationDialog }
export default OpenEvaluationDialog;